import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-687dff3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form scrollbars" }
const _hoisted_2 = { class: "queue-type-wrap" }
const _hoisted_3 = { class: "title-wrap" }
const _hoisted_4 = { class: "radio-button-wrap" }
const _hoisted_5 = { class: "button-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Hint = _resolveComponent("Hint")!
  const _component_RadioButtonGroup = _resolveComponent("RadioButtonGroup")!
  const _component_Spoiler = _resolveComponent("Spoiler")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "sign-up",
    onKeydown: _cache[13] || (_cache[13] = _withKeys(() => Object.values(_ctx.errors).some(Boolean) ? '' : _ctx.loginFx(), ["enter"])),
    tabindex: "0"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Input, {
        id: "user-name",
        modelValue: _ctx.fields.userName,
        state: _ctx.errors.userName ? 'error' : 'default',
        label: _ctx.t('formLabel.name'),
        caption: _ctx.errors.userName && _ctx.t(`authErrorList.${_ctx.errors.userName}`),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => {_ctx.fillForm({field: 'userName', value: value})}),
        onBlur: _cache[1] || (_cache[1] = (value) => _ctx.setFieldError('userName', value.length < 3, !value.length))
      }, null, 8, ["modelValue", "state", "label", "caption"]),
      _createVNode(_component_Input, {
        id: "password",
        type: "password",
        modelValue: _ctx.fields.password,
        label: _ctx.t('formLabel.password'),
        state: _ctx.errors.password ? 'error' : 'default',
        caption: _ctx.errors.password && _ctx.t(`authErrorList.${_ctx.errors.password}`),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => {_ctx.fillForm({field: 'password', value: value})}),
        onBlur: _cache[3] || (_cache[3] = (value) => _ctx.setFieldError('password', value.length <= 6, !value.length))
      }, null, 8, ["modelValue", "label", "state", "caption"]),
      (_ctx.appConfig.IS_PLATFORM_INTEGRATED)
        ? (_openBlock(), _createBlock(_component_Select, {
            key: 0,
            id: "applications",
            label: _ctx.t('formLabel.applicationName'),
            options: _ctx.applicationList,
            state: _ctx.errors.applicationName ? 'error' : 'default',
            modelValue: _ctx.fields.applicationName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => {_ctx.fillForm({field: 'applicationName', value: value})})
          }, null, 8, ["label", "options", "state", "modelValue"]))
        : (_openBlock(), _createBlock(_component_Input, {
            key: 1,
            id: "applications",
            modelValue: _ctx.fields.applicationName,
            label: _ctx.t('formLabel.applicationName'),
            state: _ctx.errors.applicationName ? 'error' : 'default',
            caption: _ctx.errors.applicationName && _ctx.t(`authErrorList.${_ctx.errors.applicationName}`),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => {_ctx.fillForm({field: 'applicationName', value: value})}),
            onBlur: _cache[6] || (_cache[6] = (value) => _ctx.setFieldError('applicationName', !value.length))
          }, null, 8, ["modelValue", "label", "state", "caption"])),
      _createVNode(_component_Input, {
        id: "account-name",
        modelValue: _ctx.fields.accountName,
        state: _ctx.errors.accountName ? 'error' : 'default',
        label: _ctx.t('formLabel.accountName'),
        caption: _ctx.errors.accountName && _ctx.t(`authErrorList.${_ctx.errors.accountName}`),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = (value) => {_ctx.fillForm({field: 'accountName', value: value})}),
        onBlur: _cache[8] || (_cache[8] = (value) => _ctx.setFieldError('accountName', !value.length))
      }, null, 8, ["modelValue", "state", "label", "caption"]),
      _createVNode(_component_Spoiler, {
        class: "optional",
        chevronPosition: "right"
      }, {
        title: _withCtx((props) => [
          _createVNode(_component_Typography, { class: "text" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('formLabel.advancedOptions')), 1),
              _createVNode(_component_Typography, {
                class: "text",
                fontColor: "var(--sui-gray-500)"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('formLabel.hint')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx((props) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Typography, { class: "text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('formLabel.queueType')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Hint, {
                class: "tooltip",
                text: _ctx.t('formLabel.tooltip')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    height: "20",
                    width: "20",
                    name: "ic20-help",
                    color: "--sui-gray-400"
                  })
                ]),
                _: 1
              }, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_RadioButtonGroup, {
                class: "queue-button",
                items: [{ label: _ctx.t('formLabel.typeList.SmartQueue'), value: 2 }, { label: _ctx.t('formLabel.typeList.ACD'), value: 1 }, { label: _ctx.t('formLabel.typeList.None'), value: 0 }],
                name: "queueType",
                size: "m",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = (value) => _ctx.fillForm({ field: 'queueType', value })),
                modelValue: _ctx.fields.queueType
              }, null, 8, ["items", "modelValue"])
            ]),
            _createVNode(_component_Input, {
              class: "node-input",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = (value) => {_ctx.fillForm({field: 'node', value: value})}),
              modelValue: _ctx.fields.node,
              id: "node",
              label: _ctx.t('formLabel.node')
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Checkbox, {
        class: "checkbox",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = (value) => {_ctx.fillForm({field: 'remember', value: value})}),
        modelValue: _ctx.fields.remember,
        id: "remember-user",
        label: _ctx.t('checkbox')
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_Button, {
        width: "fill-container",
        loading: _ctx.isLoadingLoginBtn,
        disabled: _ctx.isLoadingLoginBtn,
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loginClick()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('button')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ], 32))
}